import { useCallback } from 'react';
import { showErrorToast } from '@amigoapp/doca-react';
import { uploadTaggedPatientFiles } from '../processes/patient-files';
import { isLocalPatientFile } from '../utils/patientFiles';
import { useAnswersStore, usePatientStore } from '../stores';

function useSyncPendingPatientFiles() {
	const { answers, setAnswer } = useAnswersStore();
	const { patient, setPatient } = usePatientStore();

	const syncPatientFiles = useCallback(async (patientId, patientFiles) => {
		const insuranceCard = patient?.insurance_card_file || null;
		const otherDocument = answers?.other_document_file || null;
		const examFiles = patientFiles || [];

		const taggedFiles = [
			...(insuranceCard ? [{ file: insuranceCard, fileType: 'insurance_card' }] : []),
			...(otherDocument ? [{ file: otherDocument, fileType: 'other' }] : []),
			...examFiles.map((file) => ({ file, fileType: 'other' }))
		];

		const { data: uploadedFiles, error } = await uploadTaggedPatientFiles({ patientId, taggedFiles });

		if (error) {
			showErrorToast('Erro ao enviar os arquivos.');
			return { error };
		}

		let uploadedIndex = 0;
		const resolveUploadedFile = (file) => (isLocalPatientFile(file) ? uploadedFiles[uploadedIndex++] : file);

		const insuranceCardFile = insuranceCard ? resolveUploadedFile(insuranceCard) : null;
		const otherDocumentFile = otherDocument ? resolveUploadedFile(otherDocument) : null;
		const resolvedExamFiles = examFiles.map(resolveUploadedFile);

		if (insuranceCardFile !== insuranceCard) {
			setPatient({ patient: { ...patient, insurance_card_file: insuranceCardFile } });
		}

		if (otherDocumentFile !== otherDocument) {
			setAnswer('other_document_file', otherDocumentFile);
		}

		setAnswer('patient_files', resolvedExamFiles);

		return {
			error: null,
			insuranceCardFile,
			otherDocumentFile,
			patientFiles: resolvedExamFiles
		};
	}, [answers?.other_document_file, patient, setAnswer, setPatient]);

	return { syncPatientFiles };
}

export default useSyncPendingPatientFiles;
